import { TypographyColor } from 'melp-design/components';
import { AssignmentStatus } from 'store/assignments';

export const COLOR_BY_STATUS: Record<AssignmentStatus, TypographyColor> = {
  on: 'success',
  off: 'textSecondary',
};
